module.exports = __webpack_public_path__ + "static/media/bredon.7f808416.jpg";